import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const SortOffers: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div data-testid="offers_history_sorting" className={styles['wrapper']}>
      <UIText3>Сортировать объявления</UIText3>
      <div>{children}</div>
    </div>
  );
};
